<h2 mat-dialog-title>Your session is about to expire</h2>

<mat-dialog-content class="dialog-body">
  <p>Do you want to extend your session time?</p>
  <div class="session-time">
    <p>Session time remaining: {{ sessionTimeRemaining }}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="form-actions" align="center">
  <button mat-flat-button class="extend" color="accent" (click)="extendSession()">Extend Session</button>
  <button mat-flat-button class="logout" (click)="logout()">Log Out</button>
</mat-dialog-actions>